import React from 'react';
import * as S from './UnitsTable.style';

export default function UnitsTableHeaderItem({ label, name, color }) {
  switch (name) {
    case 'label':
      return <S.UnitsTableHeaderItemLabel color={color}>{label}</S.UnitsTableHeaderItemLabel>
    default:
      return (
        <S.UnitsTableHeaderItem>
          {label}
        </S.UnitsTableHeaderItem>
      )
  }
}